import { render, staticRenderFns } from "./CommodityAdd.vue?vue&type=template&id=4cdfc794&"
import script from "./CommodityAdd.vue?vue&type=script&lang=js&"
export * from "./CommodityAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports